<style lang="sass">
    @import ../../common/styles/mixins
    @import ../../common/styles/settings

    .back-to-top
        position: fixed
        bottom: 2rem
        right: 2rem
        z-index: 2
        color: $color-base
        cursor: pointer
        transition: transform $speed-long $authentic-motion-out, opacity $speed-long $authentic-motion-out
        transform: translate(0, 110%)
        opacity: 0
        display: flex
        align-items: center
        font-size: 0.8rem
        +media("<=1320px")
            right: 0.5rem

        +media("<=1024px")
            display: none

        &:after
            position: relative
            content: ''
            width: 3rem
            height: 3rem
            bottom: 0
            left: 0
            background-image: url(../../common/graphics/back-to-top.svg)
            background-size: contain
            background-position: center
            background-repeat: no-repeat
            margin-left: 1rem

        &.active
            transform: translate(0, 0%)
            opacity: 1


</style>


<script>

    import $ from "jquery";
    import throttle from 'lodash/throttle'

    export default {

        beforeMount() {
            window.addEventListener('scroll', this.handleScroll)
        },

        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll)
        },

        methods: {

            backToTop () {
                $("html, body").animate({
                    scrollTop: 0
                }, 900);
            },

            handleScroll: throttle( function () {
                // let st = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0)
                let st = window.scrollY || window.pageYOffset;
                let sticky = $('.back-to-top');

                if ( st < 1000 ) {
                    sticky.removeClass('active');
                } else {
                    sticky.addClass('active');
                }
            }, 50),
        }

    }


</script>